export default {
  getUserAgent: () => navigator.userAgent,
};

export const isInApp = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return !!(userAgent.match(/ecom_whitelabel_app/i)) || false;
};

export const getMobileOSName = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (userAgent) {
    if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPod/i)) {
      return 'iOS';
    }
    if (userAgent.match(/Android/i)) {
      return 'Android';
    }
  }
};
